import * as React from "react";
import type { SVGProps } from "react";
const SvgEyeOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#eye-off_svg__a)">
      <path d="M21.87 11.5a15.5 15.5 0 0 0-2.93-3.61l-1.43 1.42A13 13 0 0 1 19.83 12c-1.56 2.41-4.42 5-7.83 5a7 7 0 0 1-1.9-.27l-1.58 1.58A9.4 9.4 0 0 0 12 19c4.5 0 8.05-3.36 9.87-6.5a1 1 0 0 0 0-1M10.71 14.7l4-4 2-2 1.43-1.44 1.55-1.54a1.004 1.004 0 1 0-1.42-1.42l-1.82 1.84c-.32-.16-.64-.31-1-.45A9.4 9.4 0 0 0 12 5c-4.5 0-8 3.36-9.87 6.5a1 1 0 0 0 0 1 15.5 15.5 0 0 0 2.93 3.61c.25.22.51.44.78.64l-1.55 1.54a1 1 0 0 0 .325 1.639 1 1 0 0 0 1.095-.219l1.84-1.85 1.51-1.5zm-4.22 0A13 13 0 0 1 4.17 12C5.73 9.59 8.59 7 12 7a7 7 0 0 1 1.9.27q.51.156 1 .37L13.29 9.3a3.1 3.1 0 0 0-1.13-.3H12a3 3 0 0 0-3 3 1 1 0 0 0 0 .16c.02.391.116.775.28 1.13l-2 2a9 9 0 0 1-.79-.6z" />
    </g>
    <defs>
      <clipPath id="eye-off_svg__a">
        <path fill="#fff" d="M2 4h20v16H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgEyeOff;
